"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClient = void 0;
const contentful_1 = require("contentful");
const getClient = ({ accessToken, space = '8cecwr1x4jkf', host = 'cdn-mr.contentful.com', environment = 'master' }) => (0, contentful_1.createClient)({
    accessToken,
    host,
    space,
    environment
});
exports.getClient = getClient;
//# sourceMappingURL=getClient.js.map